// Random helper functions

export function roundTo(n, digits) {
  var negative = false;
  if (digits === undefined) {
    digits = 0;
  }
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(digits);
  if (negative) {
    n = (n * -1).toFixed(digits);
  }
  return n;
}

export function formatTime(totalSeconds) {
  const [s, ms] = totalSeconds.toString().split('.');
  const milli = !ms ? '' : `.${ms}`;
  let minutes = Math.floor(s / 60);
  const seconds = s % 60;
  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  // minutes = minutes > 0 ? `${padTo2Digits(minutes)}:` : '';
  const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}${milli}`;
  return result;
}

export function fmtMSS(s) {
  return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
}

export function millisecondFix(min_sec_msec) {
  const res = min_sec_msec.split('.');
  let msec = res[1] + '000';
  msec = msec.slice(0, 3);
  const result = `${res[0]}.${msec}`;
  return result;
}

export function rhUtc2pst(racehero_utc_time_string) {
  // 2022-10-30 17:55:26 UTC
  const inputString = racehero_utc_time_string;
  // const inputString = "2022-10-30 17:55:26 UTC";

  // Extract the date and time parts
  const [datePart, timePart] = inputString.split(' ');
  const [year, month, day] = datePart.split('-');
  const [hour, minute, second] = timePart.split(':');

  // Create a Date object in local time
  const localDate = new Date(
    `${year}-${month}-${day}T${hour}:${minute}:${second}`
  );

  // Convert local time to UTC time string
  const utcTimeString = localDate.toISOString();

  console.log(utcTimeString); // Output the UTC time string in the format "yyyy-mm-ddThh:mm:ssZ"

  // Create a Date object from the UTC time string
  const utcDate = new Date(utcTimeString);

  // Convert UTC time to Pacific Time
  const pacificTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    dateStyle: 'full',
    timeStyle: 'long',
  }).format(utcDate);

  console.log(pacificTime); // Output the Pacific Time
  return pacificTime;
}
